define('models/pages/requests/table-row',['require','underscore','chaplin','models/base/model','models/base/collection','lib/utils'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection'),
        utils = require('lib/utils');

    var TableRowModel = Model.extend({
        defaults: {

        },
        parse: function(item) {
            item.items = [];
            return item;
        }
    });


    return TableRowModel;
});
